module.exports = __webpack_public_path__ + "img/scretch.f72d5303.png";